import {SharedStoresShipmentRelationsConfig} from './shared-stores-shipment-relations.config';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromShipmentRelations from './+state/shipment-relations.reducer';
import { EffectsModule } from '@ngrx/effects';
import { ShipmentRelationsEffects } from './+state/shipment-relations.effects';
import { ShipmentRelationsFacade } from './+state/shipment-relations.facade';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(
            fromShipmentRelations.SHIPMENTRELATIONS_FEATURE_KEY,
            fromShipmentRelations.reducer
        ),
        EffectsModule.forFeature([ShipmentRelationsEffects]),
    ],
    providers: [ShipmentRelationsFacade],
})
export class SharedStoresShipmentRelationsModule {
    static forFeature(
        config: SharedStoresShipmentRelationsConfig
    ): ModuleWithProviders<SharedStoresShipmentRelationsModule> {
        return {
            ngModule: SharedStoresShipmentRelationsModule,
            providers: [config.service]
        };
    }
}
